<fa-duotone-icon class="notice-icon" [icon]="icon()"></fa-duotone-icon>
<div class="notice-body">
  <ng-content></ng-content>
</div>
@if (dismissible()) {
  <button
    type="button"
    class="notice-dismiss"
    [attr.aria-label]="'Close' | translate"
    [andorTooltip]="'Close' | translate"
    tooltipPosition="below"
    (click)="dismissed.emit()">
    <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
  </button>
}
